import type React from 'react';
import type { MODAL_NAME } from '../../../constants/modals';
import { Box, Heading, Stack } from 'braid-design-system';
import * as styles from './index.css';
import Modal from '../Modal';
import type { IModalStore } from '../../../stores/UiStore/ModalStore';
import ActionableForm, { type ActionResult } from '../ActionableForm';

interface Props {
  name: MODAL_NAME;
  title: string;
  onConfirm: () => Promise<ActionResult>;
  confirmButtonLabel: string;
  confirmButtonLoadingLabel: string;
  confirmErrorMessage: string;
  onSubmitSuccess?: (formValues: any) => void;
  modalStore: IModalStore;
  children: React.ReactNode;
  form?: React.ReactNode;
}

const ConfirmationModal: React.FC<Props> = ({
  name,
  title,
  onConfirm,
  confirmButtonLabel,
  confirmButtonLoadingLabel,
  confirmErrorMessage,
  onSubmitSuccess,
  modalStore,
  form,
  children,
}) => (
  <Modal
    modalStore={modalStore!}
    name={name}
    contentClassName={styles.confirmationModal}
  >
    {() => (
      <Box padding="xlarge">
        <ActionableForm
          initialFormValues={{}}
          onSubmit={onConfirm}
          onCancel={() => modalStore.removeModal(name)}
          submitButtonLabel={confirmButtonLabel}
          submitButtonLoadingLabel={confirmButtonLoadingLabel}
          onSubmitError={() => confirmErrorMessage}
          onSubmitSuccess={onSubmitSuccess}
        >
          <Stack space="gutter">
            <Heading level="4">{title}</Heading>
            <Box paddingY="xsmall">{children}</Box>
          </Stack>
        </ActionableForm>
        {form}
      </Box>
    )}
  </Modal>
);

export default ConfirmationModal;
